export default __webpack_public_path__ + "icon-car.119238c585156c313670908228134c48.svg";